import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const materialLookupUiNodeSpec: UiNodeSpec<'materialLookup'> = {
    cfg: () => ({
        id: getUID(),
        kind: 'materialLookup',
    }),
    controls: () => ({}),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        serialNumber: { socket: 'string', label: 'Serial Number' },
    }),
    kindLabel: 'Material Lookup',
    nodeCategory: 'argonautApi',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
        materialId: { socket: 'string', label: 'Material ID' },
        modelNumber: { socket: 'string', label: 'Model Number' },
        className: { socket: 'string', label: 'Class Name' },
    }),
    requiredSockets: (node, _, availableOutputSockets) => ({
        required: [ 'serialNumber', 'trigger', 'next' ],
        conditionallyRequired: [
            {
                kind: 'or',
                availableOptions: availableOutputSockets.filter(s => ![ 'serialNumber', 'trigger', 'next' ].includes(s)),
            },
        ],
    }),
    validator: () => true,
};
